import { createSelector } from 'reselect';

export const getBrandfolders = state => state.brandfolder && state.brandfolder.brandfolders;
export const getBrandfolderWithGenericFileSections = state =>
  state.brandfolder && state.brandfolder.brandfolderWithGenericFileSections;
export const getLoadingBrandfolder = state => state.brandfolder && state.brandfolder.loading;
export const getSelectedBrandfolderId = state =>
  state.brandfolder && state.brandfolder.selectedBrandfolderId;

export const getAllBrandfolders = createSelector(
  getBrandfolders,
  brandfolders => brandfolders && brandfolders.ids.map(id => brandfolders.entities[id])
);

export const getSelectedBrandfolder = createSelector(
  [getBrandfolders, getSelectedBrandfolderId],
  (brandfolders, selectedBrandfolderId) => {

    return brandfolders && brandfolders.entities[selectedBrandfolderId];
  }
);



// WEBPACK FOOTER //
// ./src/selectors/brandfolder.js